import { createAction, props } from '@ngrx/store';
import { BoardingCertificateCommonState } from './boarding-certificate-common.state';

/** StateDetailsActions */
const ACTION_SET = '[BoardingCertificateCommon] set';
const ACTION_UPDATE = '[BoardingCertificateCommon] update';
const ACTION_RESET = '[BoardingCertificateCommon] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setBoardingCertificateCommon = createAction(ACTION_SET, props<BoardingCertificateCommonState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateBoardingCertificateCommon = createAction(
  ACTION_UPDATE,
  props<Partial<BoardingCertificateCommonState>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetBoardingCertificateCommon = createAction(ACTION_RESET);
